// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__FcVJi","inputs":"styles_inputs__S9Ltb"};